import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';
import userAndOrganizationActivityAnalyticService from '../../../services/user-and-organization-activity-analytics.service';

const UserMetrics = () => {
  const [userRegistration, setUserRegistration] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getUserMetrics = async () => {
      setError(false);
      setLoading(true);
      try {
        const data =
          await userAndOrganizationActivityAnalyticService.getUserRegistrationAnalytics();
        setUserRegistration(data);
      } catch (err) {
        console.error('Error fetching user metrics:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getUserMetrics();
  }, []);

  if (loading) {
    return (
      <div className="mb-3">
        <Skeleton
          height={20}
          width={220}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
        />
        <Skeleton
          height={14}
          width={160}
          baseColor="#dee2e6"
          highlightColor="#e9ecef"
          style={{ marginTop: 8 }}
        />
        <Skeleton height={280} baseColor="#dee2e6" highlightColor="#e9ecef" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-danger text-center fw-semibold">
        Failed to load user registration metrics details.
      </div>
    );
  }

  const chartOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        borderRadius: 4,
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: ['Daily', 'Weekly', 'Monthly', 'All Time'],
    },
    yaxis: {
      title: { text: 'Users' },
    },
    fill: { opacity: 1 },
    tooltip: {
      y: {
        formatter: (val) => `${val} users`,
      },
    },
    colors: ['#4F46E5', '#16A34A'],
  };

  const series = [
    {
      name: 'Total Users',
      data: [
        userRegistration?.users_today,
        userRegistration?.users_this_week,
        userRegistration?.users_this_month,
        userRegistration?.total_users,
      ],
    },
  ];

  return (
    <div className="mt-3">
      <Chart options={chartOptions} series={series} type="bar" height={300} />
    </div>
  );
};

export default UserMetrics;
